import type { EntityAdapter } from 'redux-ngrx-entity';
import { createEntityAdapter } from 'redux-ngrx-entity';
import { createSelector } from 'reselect';
import type { AppState } from '../../redux/app-state';
import * as AlertsActions from './alerts.actions';
import type { AlertBody } from '@protector/entities/alerts/models';
import type { AlertsState } from '@protector/entities/alerts/__legacy__/redux.types';

const { AlertsActionsTypes } = AlertsActions;

type AlertsActionsFunctions = Omit<typeof AlertsActions, 'AlertsActionsTypes'>;
type ActionsResponses = ReturnType<AlertsActionsFunctions[keyof AlertsActionsFunctions]>;

function selectAlertUuid(alert: AlertBody): string {
  return alert.id;
}

const entity: EntityAdapter<AlertBody> = createEntityAdapter<AlertBody>({
  selectId: selectAlertUuid
});

const initialState = entity.getInitialState<AlertsState>({
  ids: [],
  entities: {},
  content: [],
  isLoading: false,
  error: null
});

export default (state = initialState, action: ActionsResponses) => {
  switch (action.type) {
    case AlertsActionsTypes.LOAD_ALERTS:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case AlertsActionsTypes.LOAD_ALERTS_SUCCESS:
      return entity.addMany(action.payload, {
        ...state,
        content: [...action.payload],
        isLoading: false,
        error: null
      });
    case AlertsActionsTypes.LOAD_ALERTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export const getAlertsUser = createSelector(
  (state: AppState) => state.entities.alerts.content,
  (alerts: AlertBody[]) => {
    return alerts;
  }
);
